import Fade from '@components/Animation/Fade';
import {SNACKBAR_CONTAINER_ID} from '@constants/general';
import PaperError from '@errors/PaperError';
import type {SnackbarMessage} from '@interfaces/Snackbar';
import classNames from 'classnames';
import type {ReactNode} from 'react';
import {Component} from 'react';
import {createPortal} from 'react-dom';

export const VISIBLE_TIMEOUT = 3000;

interface State {
    isShown: boolean;
}

export default class Snackbar extends Component<SnackbarMessage, State> {
    public static defaultProps = {
        text: '',
    };

    public state = {
        isShown: false,
    };

    private timeout: number;

    private static getContainer(): HTMLElement {
        const container = document.getElementById(SNACKBAR_CONTAINER_ID);
        if (container === null) {
            throw new PaperError('Snackbar mount point is not found');
        }

        return container;
    }

    public componentDidUpdate(prevProps: Readonly<SnackbarMessage>) {
        if (prevProps.id !== this.props.id || prevProps.text !== this.props.text) {
            if (this.timeout) {
                window.clearTimeout(this.timeout);
            }
            this.setState(
                {
                    isShown: false,
                },
                () =>
                    this.setState({
                        isShown: true,
                    }),
            );
            this.timeout = window.setTimeout(
                () => this.setState({isShown: false}),
                VISIBLE_TIMEOUT,
            );
        }
    }

    public render(): ReactNode {
        const classes = classNames({
            snackbar: !this.props.modifier,
            [`snackbar--${this.props.modifier}`]: this.props.modifier,
        });

        return createPortal(
            <Fade in={Boolean(this.state.isShown && this.props.text)} unmountOnExit>
                <div className={classes}>{this.props.text}</div>
            </Fade>,
            Snackbar.getContainer(),
        );
    }
}
